export enum ApiRequestType {
  AppSyncMutation = 'AppSyncMutation',
  AppSyncMutationWithApiKey = 'AppSyncMutationWithApiKey',
  AppSyncQuery = 'AppSyncQuery',
  AppSyncQueryWithApiKey = 'AppSyncQueryWithApiKey',
  Fetch = 'Fetch',
  ForgotPassword = 'ForgotPassword',
  SignIn = 'SignIn',
  SignOut = 'SignOut',
}
